function scoutingAggregatableSkillNamesFilter() {
    return function (skills) {
        if (!skills) {
            return 'none';
        }
        var names = skills.filter(function (item) { return !!item.includedForAggregation; }).map(function (item) { return item.name; });
        switch (names.length) {
            case 0:
                return 'none';
            case skills.length:
                return 'all skills';
            default:
                return names.join(', ');
        }
    };
}
angular
    .module('app.scouting')
    .filter('scoutingAggregatableSkillNames', scoutingAggregatableSkillNamesFilter);
;